import { NgModule } from '@angular/core';
import { EventImagePipe } from './event-image.pipe';

@NgModule({
  declarations: [EventImagePipe],
  exports: [EventImagePipe],
})
export class EventImageModule {}
